import React, { Fragment, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import ProMultiTargetSelection from './ProMultiTargetSelection';
import withModal from '../../../../../../components/global/modal/withModal';
import SelectedTargetsList from '../../SelectedTargetsList';
import { resetTargets as resetTargetsAction } from '../../../../redux/multiTargetSelection/multiTargetSelectionActions';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  albumFolderTree: PropTypes.object,
  className: PropTypes.string,
  selectedTargets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onSelectTarget: PropTypes.func,
  onDeselectTarget: PropTypes.func,
  computeNestedAlbumsTotal: PropTypes.bool,
  albumFolderSelectionEnabled: PropTypes.bool,
  photoGroupSelectionEnabled: PropTypes.bool,
  disabledTargets: PropTypes.arrayOf(PropTypes.string),
  onAlbumFolderOpen: PropTypes.func,
  rootAlbumFolderId: PropTypes.string,
};

export const PRO_MULTI_TARGET_SELECTION_MODAL =
  'PRO_MULTI_TARGET_SELECTION_MODAL';

const ProMultiTargetSelectionModalComponent = ({
  onConfirm,
  onRequestClose,
  ...props
}) => {
  const dispatch = useDispatch();
  const resetTargets = useCallback(
    () => dispatch(resetTargetsAction()),
    [dispatch],
  );
  const selectedTargets = useSelector(
    ({ pro }) => pro.multiTargetSelection.selectedTargets,
  );

  return (
    <Fragment>
      {selectedTargets.length > 0 && <SelectedTargetsList />}

      <ProMultiTargetSelection {...props} />

      <div className="d-flex mt-3">
        <Button
          className="ml-auto mr-1"
          btnStyle="secondary"
          onClick={() => {
            resetTargets();
            onRequestClose();
          }}
          btnSize="sm"
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onConfirm(selectedTargets);
            resetTargets();
            onRequestClose();
          }}
          disabled={selectedTargets.length === 0}
          btnSize="sm"
        >
          Confirm
        </Button>
      </div>
    </Fragment>
  );
};

const ProMultiTargetSelectionModal = withModal(
  ProMultiTargetSelectionModalComponent,
  {
    name: PRO_MULTI_TARGET_SELECTION_MODAL,
    contentLabel: 'Select targets',
    size: 'md',
    dismissible: false,
  },
);

ProMultiTargetSelectionModal.propTypes = propTypes;

export default ProMultiTargetSelectionModal;
